module.exports = __webpack_public_path__ + "img/mall3.5ff0c67b.png";